import { render, staticRenderFns } from "./classProblem.vue?vue&type=template&id=30a0851e&scoped=true"
import script from "./classProblem.vue?vue&type=script&lang=js"
export * from "./classProblem.vue?vue&type=script&lang=js"
import style0 from "./classProblem.vue?vue&type=style&index=0&id=30a0851e&prod&lang=scss"
import style1 from "./classProblem.vue?vue&type=style&index=1&id=30a0851e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0851e",
  null
  
)

export default component.exports